import gql from "graphql-tag";

export const GetProducts = gql`
  query GetProducts {
    stores {
      ownedProducts {
        id
        name
      }
    }
    accounts{
      partneredProducts{
        id
        name
      }
    }
  }
`;

export const GetVideos = gql`
  query GetVideos(
    $id: String
    $name: QueryableString
    $product: String
    $createdAt: QueryableDateTime
    $owner: String
    $cursor: String
    $limit: Int
  ) {
    videos(
      video: {
        id: $id
        name: $name
        createdAt: $createdAt
        owner: $owner
        product: $product
        cursor: $cursor
        limit: $limit
      }
    ) {
      id
      url
      name
      thumbnailUrl
      createdAt

      product {
        id
        name
        price
      }

      stats {
        totalOrders
        totalSales
        totalViews
      }
    }
  }
`;
